import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vds-core/theme';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
var propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  disableOutsideClick: PropTypes.bool,

  /**
   * @ignore
   */
  onDismiss: PropTypes.func.isRequired,

  /**
   * @ignore
   */
  showModal: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  opened: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   */
  fullScreenDialog: PropTypes.bool
};
var defaultProps = {
  //1.0 Props
  fullScreenDialog: false
};
var modalOpacityAnimation = /*#__PURE__*/keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = /*#__PURE__*/keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"]))); // Disable automatic passing down of props with external component (Reach UI) https://github.com/styled-components/styled-components/issues/135

var Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-1jlpnbt-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  padding: ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var fullScreenDialog = _ref.fullScreenDialog,
      viewport = _ref.viewport;
  return fullScreenDialog || viewport === 'mobile' ? 'transparent' : 'rgba(0, 0, 0, 0.8)';
}, function (_ref2) {
  var fullScreenDialog = _ref2.fullScreenDialog,
      viewport = _ref2.viewport;
  return fullScreenDialog || viewport === 'mobile' ? '0' : calculateRem(16);
}, function (_ref3) {
  var styleConfig = _ref3.styleConfig;
  return styleConfig && styleConfig.noMobilePadding && "\n    @media (max-width: ".concat(breakpoints.md, ") {\n      padding: 0;\n    }\n  ");
}, function (_ref4) {
  var showModal = _ref4.showModal,
      opened = _ref4.opened;
  return (showModal || opened) && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      animation: 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s\n        ", ";\n    "])), modalOpacityAnimation);
}, function (_ref5) {
  var unmounted = _ref5.unmounted;
  return unmounted && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      animation: ", " 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n    "])), fadeOut);
});
/**
 * @ignore
 */

var ModalOverlay = /*#__PURE__*/function (_Component) {
  _inherits(ModalOverlay, _Component);

  var _super = _createSuper(ModalOverlay);

  function ModalOverlay() {
    var _this;

    _classCallCheck(this, ModalOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDown", function (e) {
      if (e.keyCode === 27) {
        _this.props.onDismiss();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (_this.props.disableOutsideClick) return;

      if (e.target.contains(_this.overlayRef)) {
        _this.props.onDismiss();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    return _this;
  }

  _createClass(ModalOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          styleConfig = _this$props.styleConfig,
          fullScreenDialog = _this$props.fullScreenDialog,
          noMobilePadding = _this$props.noMobilePadding,
          viewport = _this$props.viewport;
      return (
        /*#__PURE__*/
        // ref will need to be changed to innerRef upon downgrade of styled-components
        React.createElement(Overlay, _extends({
          styleConfig: styleConfig,
          fullScreenDialog: fullScreenDialog,
          onMouseDown: this.onClick,
          noMobilePadding: noMobilePadding,
          viewport: viewport
        }, _defineProperty({}, this.refPath, function (elem) {
          return _this2.overlayRef = elem;
        })), children)
      );
    }
  }]);

  return ModalOverlay;
}(Component);

ModalOverlay.propTypes = propTypes;
export default ModalOverlay;